import { render, staticRenderFns } from "./CropUpload.vue?vue&type=template&id=98f2cfc4&scoped=true"
import script from "./CropUpload.vue?vue&type=script&lang=js"
export * from "./CropUpload.vue?vue&type=script&lang=js"
import style0 from "./CropUpload.vue?vue&type=style&index=0&id=98f2cfc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f2cfc4",
  null
  
)

export default component.exports